import { render, staticRenderFns } from "./Vegetable.vue?vue&type=template&id=2e7091ce&"
import script from "./Vegetable.vue?vue&type=script&lang=js&"
export * from "./Vegetable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports